export default __webpack_public_path__ + "static/media/triphop_60bpm.cf1865f9.mp3";